import React, { FC, ReactElement, useCallback, useEffect, useRef } from "react";
import { useWindowResize } from "../../../../../utils/hooks/useWindowResize";
import MenuListItem from "./MenuListItem";
import { VariableSizeList as List, VariableSizeList } from "react-window";
import { MenuListProps } from "react-select";
import Button, { ButtonModeE } from "../../../../Button/Button";
import { Span } from "../../../../Text/Text";
import { isMobileOrTablet } from "../../../../../utils/helpers/mediaQueries";

import styles from "./styles.module.scss";

interface MenuListPropTypes extends MenuListProps {
  createNewOption?: (value?: string) => void;
  label?: string;
  children: ReactElement[];
}

const MenuList: FC<MenuListPropTypes> = (props) => {
  const {
    options,
    children,
    maxHeight,
    getValue,
    createNewOption,
    label,
    selectProps: { inputValue, onMenuClose },
  } = props;
  const [value] = getValue();
  const height = 44;
  const initialOffset =
  children.length > 7 ? children.indexOf(value as any) * height : 0;
  const sizeMap = useRef({});
  const listRef = useRef<VariableSizeList>();
  const [windowWidth] = useWindowResize();
  const setSize = useCallback((index, size) => {
    sizeMap.current = { ...sizeMap.current, [index]: size };
    listRef.current.resetAfterIndex(index);
  }, []);

  const getSize = (index) => sizeMap.current[index] || height;

  const handleCreateNewOption = () => {
    createNewOption && createNewOption(inputValue);
    onMenuClose();
  };

  const mobileProps = isMobileOrTablet() ? props : {};

  return (
    <div className={styles.menuListWrapper}>
      <List
        height={children.length > 7 ? maxHeight : (children.length || 0) * height}
        width="100%"
        itemCount={children.length}
        itemSize={getSize}
        initialScrollOffset={initialOffset}
        className={styles.windowList}
        ref={listRef}
        {...mobileProps}
      >
        {({ index, style }) => (
          <MenuListItem
            item={children[index]}
            style={style}
            index={index}
            windowWidth={windowWidth}
            setSize={setSize}
          />
        )}
      </List>
      {!children.length && createNewOption && (
        <div className={styles.noOptionsWrapper}>
          <Button
            icon="addCircleFilled"
            mode={ButtonModeE.LINK}
            onClick={handleCreateNewOption}
            className={styles.createOptionButton}
          >
            Create a new {label?.toLowerCase()} {inputValue && "called"}{" "}
            {`'${inputValue}'`}
          </Button>
        </div>
      )}
      {!children.length && !createNewOption && (
        <div className={styles.noOptionsWrapper}>
          <Span>No options</Span>
        </div>
      )}
    </div>
  );
};
export default MenuList;
